/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"

const Duplicate = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 15 10">
    <g id="UX-Specification-document" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Homepage_default_VD_Desktop-Copy" transform="translate(-1121.000000, -725.000000)" fill="#3D3D36" fillRule="nonzero">
        <g id="Group-12" transform="translate(1101.000000, 577.000000)">
          <g id="Group-8" transform="translate(20.000000, 146.000000)">
            <g id="Duplicate" transform="translate(0.000000, 2.000000)">
              <path
                d="M13.3736264,0.0604395604 L3.11538462,0.0604395604 C2.71179191,0.0604395604 2.38461538,0.387616089 2.38461538,0.791208791 L2.38461538,2.38461538 L0.862637363,2.38461538 C0.459044661,2.38461538 0.131868132,2.71179191 0.131868132,3.11538462 L0.131868132,8.60989011 C0.131868132,9.01348281 0.459044661,9.34065934 0.862637363,9.34065934 L11.1208791,9.34065934 C11.3146912,9.34065934 11.5005652,9.2636678 11.637611,9.12662199 C11.7746568,8.98957617 11.8516484,8.80370216 11.8516484,8.60989011 L11.8516484,7.01648352 L13.3736264,7.01648352 C13.5683887,7.01794794 13.7556773,6.94160337 13.8939138,6.80439851 C14.0321503,6.66719365 14.1098956,6.48048209 14.1098901,6.28571429 L14.1098901,0.791208791 C14.1098956,0.59644099 14.0321503,0.409729428 13.8939138,0.272524569 C13.7556773,0.135319709 13.5683887,0.0589751408 13.3736264,0.0604395604 Z M11.1208791,2.38461538 L3.0989011,2.38461538 L3.0989011,0.791208791 L13.3736264,0.791208791 L13.3736264,6.28571429 L11.8516484,6.28571429 L11.8516484,3.11538462 C11.8516484,2.92157257 11.7746568,2.73569855 11.637611,2.59865274 C11.5005652,2.46160692 11.3146912,2.38461538 11.1208791,2.38461538 Z M11.1208791,3.11538462 L11.1208791,8.60989011 L0.862637363,8.60989011 L0.862637363,3.11538462 L11.1208791,3.11538462 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </BaseSvgIcon>
)

export default Duplicate
